/* tslint:disable:max-line-length */
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, zip, of } from 'rxjs';
import { map, mergeMap, groupBy, toArray, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  IDocumento,
  IFilter,
  IMoneda,
  IPeriodo,
  IRentabilidadAcumulada,
  IResumenMovimiento,
  ISaldoAlternativas,
  IValorCuota,
  IValorPoliza,
  IRentabilidadAcumuladaChart,
  IValorPolizaChart,
  IGroupResumenMovimiento,
  IMapaRentabilidad,
} from '../Entities/productoIndividual.entities';
import { AdministracionAhorros, key_user_info } from '../helpers/constants';
import { getFullRut, getLocalStorage } from '../helpers/helper';
import { ISaldoCuenta } from './../Entities/productoIndividual.entities';

@Injectable({
  providedIn: 'root',
})
export class ProductoIndividualService {
  private headers: HttpHeaders;
  apiBff = `${environment.url.apiBff}`;

  constructor(private http: HttpClient) {}

  getMovimientoPeriodo(
    idPoliza,
    codigoRamo,
    filters: IFilter
  ): Observable<IGroupResumenMovimiento[]> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : 12;
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : 0;
    const mesFin = filters && filters.mesFin ? filters.mesFin : 0;
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);

    const groupResumen: IGroupResumenMovimiento[] = [];

    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarResumenMovimiento/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          const resumen = data.ResumenMovimiento.filter(
            r => r.NombreMovimientoPadre !== null
          )
            .map(r => {
              if (r.NombreMovimientoPadre === 'Saldo Inicial del Periodo') {
                r.Position = 0;
                return r;
              } else if (r.NombreMovimientoPadre === 'Retiros') {
                r.Position = 3;
                return r;
              } else if (r.NombreMovimientoPadre === 'Utilidad') {
                r.Position = 2;
                return r;
              }
              r.Position = 1;
              return r;
            })
            .sort((a, b) => a.Position - b.Position);

          resumen.push({
            NombreMovimientoPadre: 'SALDO FINAL DEL PERIODO',
            GlosaCorta: 'SALDO FINAL DEL PERIODO',
            Monto: resumen.find(x => x.SaldoFinal).SaldoFinal,
            Position: 3,
          } as IResumenMovimiento);

          resumen.forEach(r => {
            const a = groupResumen.find(
              g => g.nombrePadre === r.NombreMovimientoPadre
            );
            if (a) {
              a.resumen.push(r);
            } else {
              groupResumen.push({
                CodigoMovimientoPadre: 0,
                nombrePadre:
                  r.NombreMovimientoPadre !== 'Saldo Inicial del Periodo' &&
                  r.NombreMovimientoPadre !== 'SALDO FINAL DEL PERIODO'
                    ? r.NombreMovimientoPadre
                    : null,
                resumen: [r],
              } as IGroupResumenMovimiento);
            }
          });

          return groupResumen;
        })
      );
  }

  getMovimentosPorPeriodo(
    idPoliza,
    filters: IFilter
  ): Observable<IResumenMovimiento[]> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '12';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarMovimientosPeriodo/
        ${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(map(resumen => (resumen ? resumen.ResumenMovimiento : null)));
  }

  getPeriodos(
    idPoliza,
    annoInicio = 0,
    annoFin = 0,
    mesInicio = 0,
    mesFin = 0
  ): Observable<IPeriodo[]> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = 12;
    const codMoneda = 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarPeriodos/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(map(data => (data ? data.Periodo : null)));
  }

  getMonedas(
    idPoliza,
    annoInicio = 0,
    annoFin = 0,
    mesInicio = 0,
    mesFin = 0
  ): Observable<IMoneda[]> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = 0;
    const codMoneda = 0;
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarMonedas/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(map(data => (data ? data.Moneda : null)));
  }

  getUltimaCartola(idPoliza): Observable<IDocumento> {
    const userInfo = getLocalStorage(key_user_info);
    const usuario = getFullRut(userInfo.rut);

    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Documentos/ObtenerUltimaCartola/${idPoliza}/${usuario}`
    );
  }

  getCartolaAnuales(idPoliza): Observable<IDocumento[]> {
    const token = getLocalStorage('token');

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return this.http
    .get<any>(
      `${this.apiBff}/BffSitioPrivado/policy/${idPoliza}/balance`,
      {
        headers: this.headers,
      }
    )
    .pipe(
      catchError(error => {
        console.log('error inside get: ' + JSON.stringify(error));
        return of(undefined);
      }),
      map(response => {
        if (response && response.data) {
          return response.data.map(item => ({
            Periodo: item.period,
            Nombre: item.name,
            URL: item.url,
            Categoria: item.category,
            SubSistema: item.subsystem,
          }));
        } else {
          return [];
        }
      })
    );
  }

  getRentabilidadAcumuladaPeriodo(
    idPoliza,
    filters: IFilter
  ): Observable<IRentabilidadAcumuladaChart> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '12';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const diaInicio = filters && filters.diaInicio ? filters.diaInicio : '0';
    const diaFin = filters && filters.diaFin ? filters.diaFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarRentabilidadAcumuladaPeriodo/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${diaInicio}/${diaFin}/${codMoneda}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return;
          }
          const rentabilidadAcumuladaChart = {} as IRentabilidadAcumuladaChart;
          rentabilidadAcumuladaChart.RentabilidadAcumulada = data.Rentabilidad as IRentabilidadAcumulada[];

          rentabilidadAcumuladaChart.values = data.Rentabilidad.map(d => {
            return Number(d.RentabilidadPeriodo.replace(',', '.')).toFixed(3);
          });

          rentabilidadAcumuladaChart.rentabilidadNominal = Number(
            rentabilidadAcumuladaChart.RentabilidadAcumulada[
              rentabilidadAcumuladaChart.RentabilidadAcumulada.length - 1
            ].RentabilidadPeriodo.replace(',', '.')
          );

          rentabilidadAcumuladaChart.lineChartLabels = rentabilidadAcumuladaChart.RentabilidadAcumulada.map(
            d => d.PeriodoInicial
          );

          return rentabilidadAcumuladaChart;
        })
      );
  }

  getRentabilidadAcumuladaDoceMeses(
    idPoliza
    //filters: IFilter
  ): Observable<IRentabilidadAcumuladaChart> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = '12';
    const annoInicio = 0;
    const annoFin = 0;
    const mesInicio = '0';
    const mesFin = '0';
    const diaInicio = '0';
    const diaFin = '0';
    const codMoneda = 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarRentabilidadAcumuladaPeriodo/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${diaInicio}/${diaFin}/${codMoneda}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return;
          }
          const rentabilidadAcumuladaChart = {} as IRentabilidadAcumuladaChart;
          rentabilidadAcumuladaChart.RentabilidadAcumulada = data.Rentabilidad as IRentabilidadAcumulada[];

          rentabilidadAcumuladaChart.values = data.Rentabilidad.map(d => {
            return Number(d.RentabilidadPeriodo.replace(',', '.')).toFixed(3);
          });

          rentabilidadAcumuladaChart.rentabilidadNominal = Number(
            rentabilidadAcumuladaChart.RentabilidadAcumulada[
              rentabilidadAcumuladaChart.RentabilidadAcumulada.length - 1
            ].RentabilidadPeriodo.replace(',', '.')
          );

          rentabilidadAcumuladaChart.lineChartLabels = rentabilidadAcumuladaChart.RentabilidadAcumulada.map(
            d => d.PeriodoInicial
          );

          return rentabilidadAcumuladaChart;
        })
      );
  }

  getValorPolizaPeriodo(
    idPoliza,
    filters: IFilter
  ): Observable<IValorPolizaChart> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '12';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarValorPoliza/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          const valorPolizaChart = {} as IValorPolizaChart;
          valorPolizaChart.valorPoliza = data.ValorPoliza;

          valorPolizaChart.values = valorPolizaChart.valorPoliza.map(
            d => d.Saldo / 1000000
          );
          valorPolizaChart.lineChartLabels = valorPolizaChart.valorPoliza.map(
            d => d.FechaSaldo
          );

          return valorPolizaChart;
        })
      );
  }

  getAlternativaInversion(
    idPoliza,
    filters: IFilter
  ): Observable<ISaldoAlternativas> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '12';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Totalescartolas/ListarResumenSaldoAlternativasInversion/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
    );
  }

  getSaldoPeriodo(idPoliza, filters: IFilter): Observable<ISaldoAlternativas> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '12';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Totalescartolas/ListarResumenSaldoPeriodo/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
    );
  }

  getResumenSaldoCuenta(
    idPoliza,
    filters: IFilter
  ): Observable<ISaldoAlternativas> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '02';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Totalescartolas/ListarResumenSaldoCuenta/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
    );
  }

  getIndListValoresAlternativasInversion(
    idPoliza: string,
    fecha: string
  ): Observable<any[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          environment.url.api
        }/ind/Polizas/Valorescuotas/ListarValoresAlternativasInversion/${idPoliza}/${fecha}/${getFullRut(
          userInfo.rut
        )}`
      )
      .pipe(
        mergeMap(data => {
          if (!data) {
            return [];
          }
          const newData = data.ValorCuota.map(v => {
            if (v.Descripcion === 'PESOS') {
              v.TipoCambio = null;
            }
            if (v.GlosaLarga === 'UF + 2% ANUAL' && !v.TipoRenta) {
              v.TipoRenta = 'Garantizado';
            }
            return v;
          });
          return newData as IValorCuota[];
        }),
        groupBy(
          person => person.TipoRenta,
          p => p
        ),
        mergeMap(group => zip(of(group.key), group.pipe(toArray())))
      );
  }

  getSaldoCuenta(idPoliza, filters: IFilter): Observable<ISaldoCuenta[]> {
    const userInfo = getLocalStorage(key_user_info);
    const codMovPadre = 0;
    const periodo = filters && filters.periodo ? filters.periodo : '02';
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : '0';
    const mesFin = filters && filters.mesFin ? filters.mesFin : '0';
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarSaldoCuenta/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(map(data => (data ? data.Cuenta : [])));
  }

  isTipoProductoInAdministracionAhorros(TipoProducto: string): boolean {
    return AdministracionAhorros.indexOf(TipoProducto.toLocaleLowerCase()) > -1;
  }

  getDiaHabil(): Observable<string> {
    return this.http
      .get<any>(`${environment.url.api}/com/Servicios/DiaHabil/`)
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          return data.DiaHabil;
        })
      );
  }

  getDeatlleMovimientoPeriodo(
    idPoliza,
    filters: IFilter,
    codMovPadre: number
  ): Observable<IResumenMovimiento[]> {
    const userInfo = getLocalStorage(key_user_info);
    const periodo = filters && filters.periodo ? filters.periodo : 12;
    const annoInicio = filters && filters.annoInicio ? filters.annoInicio : 0;
    const annoFin = filters && filters.annoFin ? filters.annoFin : 0;
    const mesInicio = filters && filters.mesInicio ? filters.mesInicio : 0;
    const mesFin = filters && filters.mesFin ? filters.mesFin : 0;
    const codMoneda = filters && filters.codMoneda ? filters.codMoneda : 'PS';
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Cartolas/ListarDetalleMovimiento/${idPoliza}/${codMovPadre}/${periodo}/${annoInicio}/${annoFin}/${mesInicio}/${mesFin}/${codMoneda}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          const resumen = data.ResumenMovimiento;
          return resumen.filter(r => r.Glosa.toLowerCase() !== 'total');
        })
      );
  }

  obtenerMapaRentabilidad(): Observable<IMapaRentabilidad> {
    const url = `${environment.url.api}/ind/Comunes/Widgets/ObtenerMapaRentabilidad/`;
    return this.http.get<IMapaRentabilidad>(url);
  }

  validarClienteAhorro() {
    const userInfo = getLocalStorage(key_user_info);
    const token = getLocalStorage('token');

    this.headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return this.http
      .get<any>(
        `${this.apiBff}/BffSitioPrivado/ValidateClientSavings/${getFullRut(
          userInfo.rut
        )}`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error('Error al obtener los datos:', err.message);
          return of([]);
        }),
        map(data => {
          if (!data) {
            throw new Error('Data is undefined or null');
          }

          if (!data.clientSavings) {
            throw new Error('clientSavings is undefined or null');
          }

          if (!Array.isArray(data.clientSavings.productList)) {
            throw new Error('productList is not an array or undefined');
          }

          return {
            LineaNegocio: data.clientSavings.businessLine || '',
            ListaProductos: data.clientSavings.productList.map(product => {
              if (!product) {
                throw new Error('Product is undefined or null');
              }

              return {
                CodigoCliente: product.clientCod || '',
                Codigo: product.cod || '',
                IdPoliza: product.policyId || '',
                Nombre: product.name || '',
                Poliza: product.policy || '',
                IdCliente: product.clientId || '',
              };
            }),
          };
        })
      );
  }
}
